import { apiFetch } from "./client";

export type TotpStatus = { enabled: boolean };
export type TotpSetup = { secretBase32: string; provisioningUri: string };
export type TotpConfirm = { enabled: boolean; recoveryCodes: string[] };

export const totpApi = {
  status: () => apiFetch<TotpStatus>("/me/totp/status"),
  setup: () => apiFetch<TotpSetup>("/me/totp/setup", { method: "POST" }),
  confirm: (code: string) =>
    apiFetch<TotpConfirm>("/me/totp/confirm", { method: "POST", body: { code } }),
  regenerateRecoveryCodes: () =>
    apiFetch<{ recoveryCodes: string[] }>("/me/totp/recovery-codes", { method: "POST" }),
  disable: () => apiFetch<TotpStatus>("/me/totp/disable", { method: "POST" }),
};
